import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { ACCOUNT_KEY } from '../../providers/AccountProvider'

const LogoutRoute: React.FC = () => {
  const { logout, isLoading } = useAuth0()

  React.useEffect(() => {
    if (isLoading) return
    try {
      localStorage.removeItem('session_user')
      localStorage.removeItem('session_token')
      localStorage.removeItem('version')
      localStorage.removeItem(ACCOUNT_KEY)
      logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })
    } catch (error) {
      console.warn('User had no active session')
    }
  }, [isLoading, logout])

  return null
}

export default LogoutRoute
